import { render, staticRenderFns } from "./ConfirmAddProduct.pug?vue&type=template&id=f2414b24&lang=pug&"
import script from "./ConfirmAddProduct.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports